import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFlag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFlag2"><Path d="M11.7975 15.8054C9.60407 15.1904 7.66645 14.6672 5.5 15.5659V22H4V3.31173L4.41781 3.10532C7.30137 1.68079 9.86003 2.39852 12.1345 3.03652L12.2025 3.0556C14.5359 3.70992 16.5799 4.2603 18.9178 3.10532L20 2.5707V15.5493L19.5822 15.7557C16.6986 17.1803 14.14 16.4625 11.8655 15.8245L11.7975 15.8054Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFlag2;
